<yo-tab-menu [tabs]="stockFeatures" [selectedTab]="selectedFeature"></yo-tab-menu>
<router-outlet></router-outlet>
